import { Card, Flex, Text, Box, Avatar, Badge, Progress } from '@radix-ui/themes';
import { useState, useEffect } from 'react';
import CircleProgress from '../../shared/CircleProgress';
import { reportService } from '../../../services/teacher/reportService';
import { COMPETENCY_COLORS } from '../../../utils/constants';
import UserAvatar from '../../common/UserAvatar';
const StudentPerformance = ({ studentSummary, onSelect }) => {
    const [selectedReport, setSelectedReport] = useState({});
    const [loadingReport, setLoadingReport] = useState(false);

    console.log('studentSummary', studentSummary);

    useEffect(() => {
        if (selectedReport.id) {
            setLoadingReport(true);
            try {
                if (selectedReport.type === 'student') {
                    getStudentReport(selectedReport.id);
                } else if (selectedReport.type === 'course') {
                    getCourseReport(selectedReport.id);
                }
            } catch (error) {
                console.error('Error fetching report:', error);
            } finally {
                setLoadingReport(false);
            }
        }
    }, [selectedReport]);



    return (
        <Card>
            <Flex direction="column" gap="3">
                {studentSummary.map(student => (
                    <Box key={student.id} maxWidth="500px">
                        <Flex direction="row" align="center" justify="between" gap="4" mb="2" style={{ cursor: 'pointer' }}
                            onClick={() => {
                                if(student?.payment_status == 'active'){
                                    onSelect?.({ type: 'student', id: student.id })
                                }
                            }}
                        >
                            <Flex direction="row" align="center" justify="start" gap="1">
                                <UserAvatar size="3" user={{profile_picture:student.profile_picture, firstname:student.name}} radius="full" />
                                <Flex direction="column" align="start" justify="start" gap="1">
                                    <Text size="1" color="gray">{student.name}</Text>
                                    {student.payment_status != 'active' ? (
                                        <Badge color="red">Inactive</Badge>
                                    ) : (
                                        <Badge color="green">Active</Badge>
                                    )}
                                </Flex>
                            </Flex>
                            <Flex direction="row" align="center" justify="left" gap="1">
                                <CircleProgress
                                    progress={student.average_score}
                                    size={40}
                                    strokeWidth={3}
                                    color="var(--accent-9)"
                                    label={Math.floor(student.average_score)}
                                    labelSize="1"
                                    selected={selectedReport.type === 'student' && selectedReport.id === student.id}
                                />
                                <Flex direction="column" align="start" justify="start" gap="1">
                                    <Progress value={student.average_vocabulary_score} color={COMPETENCY_COLORS['vocabulary']} style={{ width: '50px' }}/>
                                    <Progress value={student.average_concept_score} color={COMPETENCY_COLORS['concept']} style={{ width: '50px' }}/>
                                    <Progress value={student.average_application_score} color={COMPETENCY_COLORS['application']} style={{ width: '50px' }} />
                                </Flex>
                            </Flex>
                        </Flex>
                    </Box>
                ))}
            </Flex>
        </Card>
    );
};


export default StudentPerformance;